const sidebarContainer = `fixed inset-0 z-20 transform transition-transform duration-300 ease-in-out md:relative md:translate-x-0 md:flex`;

const getSidebarClass = (isSidebarOpen: boolean) => 
  `${sidebarContainer} ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}`;

export default getSidebarClass;

export const childrenContainer ="flex-grow"